import Swal from 'sweetalert2';
import {
  FETCH_TECHNICIAN,
  SUBMIT_TECHNICIAN,
  DELETE_TECHNICIAN,
  REFRESH_TECHNICIAN_DATATABLES,
} from './_types';
import { API_URL, API_RESPONSE_STATUS, API_RESPONSE_MESSAGE, API_RESPONSE } from '../constants/env';
import { authApiHeader } from '../helpers/apiHeader';

export const fetchTechnician = () => {
  return (dispatch) => {
    return fetch(`${API_URL}/technician`, {
      method: 'GET',
      headers: authApiHeader(),
    })
      .then((response) => response.json())
      .then((response) => {
        switch (response[API_RESPONSE_STATUS]) {
          case API_RESPONSE.SUCCESS:
            dispatch({ type: FETCH_TECHNICIAN, result: response.data });
            break;

          case API_RESPONSE.FAILED:
          default:
            dispatch({ type: FETCH_TECHNICIAN, result: [] });
            Swal.fire('Fetch Technician Failed', response[API_RESPONSE_MESSAGE], 'error');
        }
      });
  };
};

export const refreshTechnicianDatatables = () => {
  return (dispatch) => {
    dispatch({ type: REFRESH_TECHNICIAN_DATATABLES });
  };
};

/**
 * @param data      nik, name
 */
export const submitTechnician = (data) => {
  return (dispatch) => {
    return fetch(`${API_URL}/technician`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: authApiHeader(),
    })
      .then((response) => response.json())
      .then((response) => {
        switch (response[API_RESPONSE_STATUS]) {
          case API_RESPONSE.SUCCESS:
            Swal.fire('Submit Success', response[API_RESPONSE_MESSAGE], 'success');
            dispatch({ type: SUBMIT_TECHNICIAN, result: response });
            break;

          case API_RESPONSE.FAILED:
          default:
            Swal.fire('Submit Failed', response[API_RESPONSE_MESSAGE], 'error');
            return Promise.reject(response[API_RESPONSE_MESSAGE]);
        }
      })
      .then(() => dispatch(refreshTechnicianDatatables()))
      .then(() => dispatch(fetchTechnician()));
  };
};

/**
 * @param id
 * @param data      nik, name
 */
export const updateTechnician = (id, data) => {
  return (dispatch) => {
    return fetch(`${API_URL}/technician/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
      headers: authApiHeader(),
    })
      .then((response) => response.json())
      .then((response) => {
        switch (response[API_RESPONSE_STATUS]) {
          case API_RESPONSE.SUCCESS:
            Swal.fire('Submit Success', response[API_RESPONSE_MESSAGE], 'success');
            dispatch({ type: SUBMIT_TECHNICIAN, result: response });
            break;

          case API_RESPONSE.FAILED:
          default:
            Swal.fire('Submit Failed', response[API_RESPONSE_MESSAGE], 'error');
            return Promise.reject(response[API_RESPONSE_MESSAGE]);
        }
      })
      .then(() => dispatch(refreshTechnicianDatatables()))
      .then(() => dispatch(fetchTechnician()));
  };
};

/**
 * @param id
 */
export const deleteTechnician = (id) => {
  return (dispatch) => {
    return fetch(`${API_URL}/technician/${id}`, {
      method: 'DELETE',
      headers: authApiHeader(),
    })
      .then((response) => response.json())
      .then((response) => {
        switch (response[API_RESPONSE_STATUS]) {
          case API_RESPONSE.SUCCESS:
            Swal.fire('Delete Success', response[API_RESPONSE_MESSAGE], 'success');
            dispatch({ type: DELETE_TECHNICIAN, result: response });
            break;

          case API_RESPONSE.FAILED:
          default:
            Swal.fire('Delete Failed', response[API_RESPONSE_MESSAGE], 'error');
            return Promise.reject(response[API_RESPONSE_MESSAGE]);
        }
      })
      .then(() => dispatch(refreshTechnicianDatatables()))
      .then(() => dispatch(fetchTechnician()));
  };
};
